import React from 'react';
import { Card } from '../ui';
import type { CompanyPreview } from '../../client/onboardingClient';

/**
 * Sign-up "we already know you" (ADR 0008, flow B): the company Robbie has
 * on file for the email's domain. Shown, never acted on — creating the
 * account is what links it.
 */
export const KnownCompanyCard: React.FC<{ company: CompanyPreview }> = ({ company }) => {
  const host = company.website?.replace(/^https?:\/\//, '');
  return (
    <Card ai title="I think I know your company" className="mb-[16px]">
      <p className="text-body text-ink">
        <span className="font-semibold">{company.name}</span>
        {host && <span className="text-ink-muted"> · {host}</span>}
      </p>
      <p className="mt-s2 text-meta text-ink-muted">
        {company.status === 'verified'
          ? "They're a verified company with me. Create your account and I'll have what I know ready for you."
          : "I've come across them before. Create your account and I'll have what I know ready for you."}
      </p>
    </Card>
  );
};

export default KnownCompanyCard;
